import { render, staticRenderFns } from "./BillNote.vue?vue&type=template&id=15ff8ffc"
import script from "./BillNote.vue?vue&type=script&lang=js"
export * from "./BillNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports